import { useGetVat } from 'queries';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledSelect } from 'components/shared';

type Props = {
  control: Control<any>;
};

export default function VatSelectSection({ control }: Props) {
  const { t } = useTranslation();
  const { data: vatOptions } = useGetVat();

  return (
    <ControlledSelect
      control={control}
      name="vatSvc"
      variant="outlined"
      label={t('surchargesMaintenance.form.vatSvc')}
      options={vatOptions ?? []}
    />
  );
}
